import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import { LocaleCode } from 'core/util/Locale';

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        debug: false,
        lng: LocaleCode.en_US,
        fallbackLng: LocaleCode.en_US,
        whitelist: Object.values(LocaleCode),
        backend: {
            loadPath: (languages: any, namespaces: any): string =>
                `/rsrc2/l10n/${namespaces[0]}/${languages[0]}.json?t=1648233292662`,
        },
    });

export default i18n;
